if($('#customerProductsDatatable').length > 0) {
    url = $('#customerProductsDatatable').attr('data-url');
    dt = $("#customerProductsDatatable").DataTable({
        searchDelay: 500,
        order: [[0, 'desc']],
        language: window.datatableLanguage,
        searching: true,
        serverSide: true,
        processing: true,
        responsive: true,
        ajax: url,
        select: {
            style: 'os',
            selector: 'td:first-child',
            className: 'row-selected'
        },
        columns: [
            {data : 'id'},
            {data : 'date'},
            {data : 'total'},
            {data : 'confirmed'},
            {data : 'actions'},
        ],
        columnDefs: [
            {
                targets: 0,
                orderable: true
            },
            {
                targets: 1,
                orderable: true
            },
            {
                targets: 2,
                orderable: true
            },
            {
                targets: 3,
                orderable: true
            },
            {
                targets: 4,
                orderable: false
            },
        ]
    });

    const filterSearch = document.querySelector('[data-kt-table-filter-customerProductsDatatable="search"]');
    filterSearch.addEventListener('keyup', function (e) {
        dt.search(e.target.value).draw();
    });
}
